import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';
import "../../sass/components/components.genericCard.scss";

const GenericCardRelatedResources = ({ postItem, index, url, external }) => {
    return (
        <>
            {external === 'no' &&
                <Link rel="noreferrer" to={`/${url}/${postItem.slug}/`} className="cp-genericCardWrapper__section l--borderRadiusLarge l--gridBorder" key={index}>
                    <span className="cp-genericCardWrapper__image">
                        {postItem.featuredImage ?
                            <>
                                <GatsbyImage image={getImage(postItem.featuredImage.node.gatsbyImage)} alt={postItem.featuredImage.node.altText} />
                            </>
                            :
                            <>
                                <StaticImage src="../../images/post-placeholder.png" alt="" />
                            </>
                        }

                    </span>
                    <span className="cp-genericCardWrapper__content l--padding l-alignment">
                        <div>
                            <h3 className="l--flex l-nobullet">
                                {postItem.genericResourceFilters ?
                                    <span className="cp-genericCardWrapper__type">
                                        {postItem.genericResourceFilters.nodes[0].name === "analystreport" ? "// Analyst Report" :
                                            postItem.genericResourceFilters.nodes[0].name === "podcast" ? "// Podcast" :
                                                postItem.genericResourceFilters.nodes[0].name === "whitepaper" ? "// White Paper" :
                                                    `// ${postItem.genericResourceFilters.nodes[0].name}`
                                        }
                                    </span>
                                    :
                                    postItem.eventsPostFields ?
                                        <span className="cp-genericCardWrapper__type">{postItem.eventsPostFields.eventType === "virtual" ? "On Demand Webinar" : "Upcoming Event"}</span>
                                        :
                                        <span className="cp-genericCardWrapper__type">{postItem.nodeType}</span>
                                }
                            </h3>
                            {postItem.resourcePostTypeContent.resourceTitle ?
                                <h2 dangerouslySetInnerHTML={{ __html: postItem.resourcePostTypeContent.resourceTitle }} />
                                :
                                <>
                                    {postItem.title &&
                                        <h2 dangerouslySetInnerHTML={{ __html: postItem.title }} />
                                    }
                                </>
                            }
                            {postItem.resourcePostTypeContent.resourceTeaser ?
                                <p dangerouslySetInnerHTML={{ __html: postItem.resourcePostTypeContent.resourceTeaser.length > 100 ? postItem.resourcePostTypeContent.resourceTeaser.substring(0, 100) + "..." : postItem.resourcePostTypeContent.resourceTeaser }} />
                                :
                                <>
                                    {postItem.excerpt ?
                                        <div dangerouslySetInnerHTML={{ __html: postItem.excerpt.length > 100 ? postItem.excerpt.substring(0, 100) + "..." : postItem.excerpt }} />
                                        :
                                        ""
                                    }
                                </>
                            }
                        </div>
                        <span className="l--link">{`Read More >>`}</span>
                    </span>
                </Link>
            }
            {/* For external links sections like In-news */}
            {external === 'yes' &&
                <a target="_blank" rel="noreferrer" href={url} className="cp-genericCardWrapper__section l--borderRadiusLarge l--gridBorder" key={index}>
                    <span className="cp-genericCardWrapper__image">
                        {postItem.featuredImage ?
                            <>
                                <GatsbyImage image={getImage(postItem.featuredImage.node.gatsbyImage)} alt={postItem.featuredImage.node.altText} />
                            </>
                            :
                            <>
                                <StaticImage src="../../images/post-placeholder.png" alt="" />
                            </>
                        }

                    </span>
                    <span className="cp-genericCardWrapper__content l--padding l-alignment">
                        <div>
                            <h3 className="l--flex l-nobullet">
                                {postItem.genericResourceFilters ?
                                    <span className="cp-genericCardWrapper__type">
                                        {postItem.genericResourceFilters.nodes[0].name === "analystreport" ? "// Analyst Report" :
                                            postItem.genericResourceFilters.nodes[0].name === "podcast" ? "// Podcast" :
                                                postItem.genericResourceFilters.nodes[0].name === "whitepaper" ? "// White Paper" :
                                                    `// ${postItem.genericResourceFilters.nodes[0].name}`
                                        }
                                    </span>
                                    :
                                    postItem.eventsPostFields ?
                                        <span className="cp-genericCardWrapper__type">{postItem.eventsPostFields.eventType === "virtual" ? "On Demand Webinar" : "Upcoming Event"}</span>
                                        :
                                        <span className="cp-genericCardWrapper__type">{postItem.nodeType}</span>
                                }
                            </h3>
                            {postItem.resourcePostTypeContent.resourceTitle ?
                                <h2 dangerouslySetInnerHTML={{ __html: postItem.resourcePostTypeContent.resourceTitle }} />
                                :
                                <>
                                    {postItem.title &&
                                        <h2 dangerouslySetInnerHTML={{ __html: postItem.title }} />
                                    }
                                </>
                            }
                            {postItem.resourcePostTypeContent.resourceTeaser ?
                                <p dangerouslySetInnerHTML={{ __html: postItem.resourcePostTypeContent.resourceTeaser.length > 100 ? postItem.resourcePostTypeContent.resourceTeaser.substring(0, 100) + "..." : postItem.resourcePostTypeContent.resourceTeaser }} />
                                :
                                <>
                                    {postItem.excerpt ?
                                        <div dangerouslySetInnerHTML={{ __html: postItem.excerpt.length > 100 ? postItem.excerpt.substring(0, 100) + "..." : postItem.excerpt }} />
                                        :
                                        ""
                                    }
                                </>
                            }
                        </div>
                        <span className="l--link">{`Read More >>`}</span>
                    </span>
                </a>
            }
        </>
    );
}

export default GenericCardRelatedResources;